window.app_models.amenities = {
    "id":null,
    "walk_in_closet":null,
    "laundry_room":null,
    "low_e_windows":null,
    "media_room":null,
    "great_room":null,
    "front_porch":null,
    "pets_allowed":null,
    "car_garage":null,
    "parking_spaces":null,
    "washer_dryer":null,
    "gas":null,
    "electric":null,
    "open_garage":null,
    "lease_rate":null,
    "pet_rent":null,
    "parking_fees":null,
    "trash":null,
    "other":null,
    "beginning_date":null,
    "end_date":null,
    "mtm_beginning_date":null,
    "mtm_end_date":null,
    "insurance_approved_extension_date":null,
    "note":null,
    "property_id":null,
    "property_lease_term_id":null,
    "grace_period_id":null,
    "ac":null,
    "fenced_yard":null,
    "fridge":null,
    "washer":null,
    "dryer":null,
    "pool_service":null,
    "gardener":null,
    "microwave":null,
    "dryer_type":null,
    "spa_service":null,
    "stairs":null,
    "window_coverings":null,
    "property_lease_term":window.app_models.option
};


// WEBPACK FOOTER //
// ./resources/assets/js/models/amenities.js